// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import qs from 'qs'
import './assets/less/app.system.less'
import pagination from './components/pagination'

import jquery from 'jquery'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'

import  VueQuillEditor from 'vue-quill-editor'

/******** 发送请求前配置请求及参数 ********/
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.interceptors.request.use((config) => {
    if(config.method  === 'post'){
        // 上传到七牛时如果在参数中添加login_token会报错
        if (config.url == 'http://upload.qiniu.com') return config
        if (!config.data) config.data = {}
        config.data = qs.stringify(config.data,{ allowDots:true })
    }
    return config
},(error) =>{
    _.toast("错误的传参", 'fail')
    return Promise.reject(error)
})

axios.interceptors.response.use((res) => {
    if(!res.data.success && res.data.data == 201) {
        //alert('会话失效，请重新登录')
        window.location.href=API_ROOT.systemHeader + '/reginalAgent/login'
    }
    return res
},(error) =>{
    _.toast("网络异常", 'fail')
    return Promise.reject(error)
})

Vue.prototype.$http = axios
/******** 发送请求前配置请求及参数 END ********/


Vue.config.productionTip = false

// 注册分页组件
Vue.component(pagination.name, pagination)

// 注册ElementUI组件
Vue.use(ElementUI)

// 注册富文本组件
Vue.use(VueQuillEditor)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js